<div class="row">
  <div class="col">
    <div class="card">
      <div class="card-header">
        <p class="card-title h4 float-left">{{ title }}</p>
        <button
          type="button"
          class="close float-right"
          aria-label="Close"
          (click)="activeModal.dismiss('Cross click')"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="card-body">
        <form
          action=""
          [formGroup]="expenseForm"
          (ngSubmit)="registerExpense()"
          class="form-horizontal form-material"
          id="expenseform"
          novalidate
        >
          <div class="form-group m-t-20">
            <div class="col-xs-12">
              <app-form-error-wrapper
                [control]="expenseForm.controls['monto']"
                [controlName]="'Monto'"
              >
                <label for="monto">Monto</label>
                <input
                  class="form-control"
                  type="number"
                  id="monto"
                  formControlName="monto"
                  placeholder="monto"
                />
              </app-form-error-wrapper>
            </div>
          </div>
          <div class="form-group m-t-20">
            <div class="col-xs-12">
              <app-form-error-wrapper
                [control]="expenseForm.controls['descripcion']"
                [controlName]="'Descripción'"
              >
                <label for="descripcion">Descripción</label>
                <input
                  class="form-control"
                  type="text"
                  id="descripcion"
                  formControlName="descripcion"
                  placeholder="descripción"
                />
              </app-form-error-wrapper>
            </div>
          </div>
          <div class="form-group text-center m-t-20">
            <div class="col-xs-12">
              <button
                class="btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light"
                [disabled]="expenseForm.invalid || isLoading"
              >
                <app-button-loader
                  [isLoading]="isLoading"
                  [label]="'Agregar'"
                ></app-button-loader>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
